import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalizeLoader, GuiFacade } from '@app/store/gui';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { countriesListActions } from '../actions/countries-list.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class CountriesListEffects {
    private readonly actions$ = inject(Actions);
    private readonly httpService = inject(HttpService);
    private readonly guiFacade = inject(GuiFacade);

    getCountries$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(countriesListActions.getCountriesList),
            switchMap(() =>
                this.httpService.getCountriesList().pipe(
                    map((payload) => countriesListActions.getCountriesListSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(countriesListActions.getCountriesListError({ code: error.status }))),
                    finalizeLoader(this.guiFacade, 'countries-get'),
                ),
            ),
        );
    });
}
